"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrFaq = void 0;
const react_1 = __importDefault(require("react"));
const fdr_regular_fusion_fdr_accordion_1 = require("@hotelplan/fdr.regular.fusion.fdr-accordion");
const fdr_faq_styles_1 = require("./fdr-faq.styles");
function FdrFaq(props) {
    const { fgColor, bgColor, question, answer, className } = props;
    return (react_1.default.createElement(fdr_faq_styles_1.FaqSectionWrapper, { className: className, "data-id": "faq-item" },
        react_1.default.createElement(fdr_regular_fusion_fdr_accordion_1.FdrAccordion, null,
            react_1.default.createElement(fdr_faq_styles_1.FdrAccordionItemWrapper, { fontColor: fgColor, bgColor: bgColor, title: question },
                react_1.default.createElement(fdr_faq_styles_1.FaqText, { className: "faq-text", dangerouslySetInnerHTML: { __html: answer } })))));
}
exports.FdrFaq = FdrFaq;
//# sourceMappingURL=fdr-faq.js.map